import $ from 'jquery'
window.jQuery = $; window.$ = $
require('@/js/sageflo/login.js')